import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {AthletePropositionBetModuleConfig} from "./athlete-proposition-bet-module.config";
import {AthletePropositionBetModuleState} from "./models/athlete-proposition-bet-module.state";

export class AthletePropositionBetModuleStore extends BaseMobxStore {
  static injectables = [AthletePropositionBetModuleConfig, AthletePropositionBetModuleState];
}

